export const timeout = (decoratee, delayMs) => {
    return (...args) =>
        Promise.race([
            decoratee(...args),
            new Promise(function (resolve, reject) {
                setTimeout(() => reject(new Error('Timeout')), delayMs)
            }),
        ])
}
